<template>
  <v-container>
    <template v-if="currentUser.permittedSituations.includes(situation)">
      <slot />
    </template>
    <template v-else>
      <v-col cols="6" offset="3" class="text-center">
        <v-alert class="mt-5 d-inline-block" dense outlined type="error">
          権限がありません。
        </v-alert>
      </v-col>
    </template>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    situation: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    })
  }
}
</script>

<style scoped></style>
